"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var formRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  props: {},
  relatedConcepts: [{
    module: 'HTML',
    concept: {
      name: 'form',
      attributes: [{
        name: 'name',
        constraints: ['set']
      }]
    }
  }, {
    module: 'HTML',
    concept: {
      name: 'form',
      attributes: [{
        name: 'aria-label',
        constraints: ['set']
      }]
    }
  }, {
    module: 'HTML',
    concept: {
      name: 'form',
      attributes: [{
        name: 'aria-labelledby',
        constraints: ['set']
      }]
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = formRole;
exports.default = _default;